"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionTags = exports.DimensionIds = void 0;
//Dimensions: columns in CAMPAIGN table
exports.DimensionIds = {
    GRANULARITY_COLUMN_ID: "GRANULARITY",
    CAMPAIGN_ID_COLUMN_ID: "CAMPAIGN_ID",
    LINEITEM_ID_COLUMN_ID: "LINEITEM_ID",
    LANDING_ID_COLUMN_ID: "LANDING_ID",
    CREATIVE_ID_COLUMN_ID: "CREATIVE_ID",
    CREATIVE_TYPE_COLUMN_ID: "CREATIVE_TYPE",
    CREATIVE_NAME: "CREATIVE_NAME",
    EXCHANGE_COLUMN_ID: "EXCHANGE",
    SKAD_EXCHANGE_DIGIT: "SKAD_EXCHANGE_DIGIT",
    SKAD_DOW_DIGIT: "SKAD_DOW_DIGIT",
    APP_BUNDLE_COLUMN_ID: "APP_BUNDLE",
    CAMPAIGN_BUNDLE_COLUMN_ID: "BUNDLE_ID",
    LAST_BUNDLE_COLUMN_ID: "USER_LAST_BUNDLE",
    TAG_ID_COLUMN_ID: "TAG_ID",
    CITY_COLUMN_ID: "GEO_CITY",
    SKAN_FIDELITY_COLUMN_ID: "FIDELITY",
    CONVERSION_VALUE: "CONVERSION_VALUE",
    COARSE_CONVERSION_NUMBER: "COARSE_CONVERSION_NUMBER",
    BUCKET_BID_FLOOR_COLUMN_ID: "BUCKET_BID_FLOOR",
    ORGANIZATION_COLUMN_ID: "ORGANIZATION",
    PRICE_ORIGINAL: "PRICE_ORIGINAL",
    DEVICE_OS_COLUMN_ID: "DEVICE_OS",
    CREATIVE_SIZE_COLUMN_ID: "BANNER_FORMAT_SIZE",
    INVENTORY_CREATIVE_TYPE_COLUMN_ID: "INVENTORY_CREATIVE_TYPE",
    //_INT suffix for numeric Dimensions corresponding to boolean(mostly) typed Dimensions
    AUTO_STOREKIT_RESPONSE: "AUTO_STOREKIT_RESPONSE_INT",
    DUAL_ENDCARD_RESPONSE: "DUAL_ENDCARD_RESPONSE_INT",
    MODEL_IGNORED: "MODEL_IGNORED_INT",
    TRACKING_ALLOWED: "TRACKING_ALLOWED_INT",
    DIRECT_TRAFFIC: "DIRECT_TRAFFIC_INT",
    SKOVERLAY_RESPONSE: "SKOVERLAY_RESPONSE_INT",
    SKIP_TO_STORE_RESPONSE: "SKIP_TO_STORE_RESPONSE_INT",
};
var DimensionTags;
(function (DimensionTags) {
    DimensionTags["Report"] = "REPORT";
})(DimensionTags || (exports.DimensionTags = DimensionTags = {}));
